import {
    instance
} from '../../util/http'
import apis from '../../config/apis'

// 获取代买人列表
const agentList = (AgentId,page,pageSize) => {
    return instance.get(apis.Agent.GetAddress + "?AgentId=" + AgentId + "&page=" + page + "&pageSize=" + pageSize)
}
// 获取昵称列表
const nickNameList = (NickName,page,pageSize) => {
    return instance.get(apis.Agent.GetNickName + "?NickName=" + NickName + "&page=" + page + "&pageSize=" + pageSize)
}
// 获取代买人地址详情
const getDetail = (id) => {
    return instance.get(apis.Agent.GetDetail + "/" + id)
}
// 添加代买人组信息（有昵称）
const addGroup = ({
    agentNickName,
    agentCellPhone,
    province,
    city,
    district,
    details,
    districtCode
}) => {
    return instance.post(apis.Agent.addGroupInfo, {
        agentNickName: agentNickName,
        agentCellPhone: agentCellPhone,
        province: province,
        city: city,
        district: district,
        details: details,
        districtCode: districtCode
    })
}
// 添加代买人组内信息（）
const addAddress = ({
    agentId,
    agentCellPhone,
    province,
    city,
    district,
    details,
    districtCode
}) => {
    return instance.post(apis.Agent.addAddress, {
        agentId: agentId,
        agentCellPhone: agentCellPhone,
        province: province,
        city: city,
        district: district,
        details: details,
        districtCode: districtCode
    })
}


// 编辑代买人昵称
const update = ({
    id,
    nickName,
}) => {
    return instance.put(apis.Agent.EditNickName, {
        agentId: id,
        agentNickName: nickName
    }) 
}
// 编辑代买人组内地址
const updateAddress = ({
    id,
    agentCellPhone,
    province,
    city,
    district,
    details,
    districtCode
}) => {
    return instance.put(apis.Agent.EditNEditAddress, {
        id: id,
        cellPhone: agentCellPhone,
        province: province,
        city: city,
        district: district,
        details: details,
        districtCode: districtCode
    }) 
}
// 删除地址
const deleteAddress = (id) => {
    return instance.delete(apis.Agent.DeleteAddress + "/" + id)
}
// 删除昵称
const deleteNickName = (id) => {
    return instance.delete(apis.Agent.DeleteNickName + "/" + id)
}

export default {
    agentList,
    nickNameList,
    getDetail,
    addGroup,
    addAddress,
    update,
    updateAddress,
    deleteAddress,
    deleteNickName
}